import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Forms from './components/Forms';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useLocation, useParams } from 'react-router-dom';

const PedidoCadastro = ({
  isReadOnly = false,
  id: propId,
  hideHeader = false,
  hideObservacaoComplemento = false,
  depotId: propDepotId = null
}) => {
  const {
    id: paramId
  } = useParams();
  const location = useLocation();
  const depotId = propDepotId || new URLSearchParams(location.search).get('depotId');
  const id = propId || paramId;
  const isEditing = !!id && !isReadOnly;
  const isViewing = isReadOnly;
  return <Container fluid>
      {!hideHeader && <Row>
          <Col md={12}>
            <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Pedidos',
          path: '/pages/pedidos'
        }, {
          name: isViewing ? 'Detalhes do Pedido' : isEditing ? 'Editar Pedido' : 'Novo Pedido'
        }]} />
          </Col>
        </Row>}
      
      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} depotId={depotId} hideObservacaoComplemento={hideObservacaoComplemento} />
        </Col>
      </Row>
    </Container>;
};

export default PedidoCadastro;


